// /new?connector=<connector id>&record=<record id>: the target of a "Send with eSignIt" button in a CRM (design §7).
// Creates a draft already linked to that record (and titled after it), then opens the editor.
import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import type { Envelope } from "../lib/types";
import { ErrorNote, Spinner } from "../components/ui";

export default function NewFromLink() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const connectorId = params.get("connector");
    const recordId = params.get("record");
    api<Envelope>("/envelopes", { body: connectorId && recordId ? { link: { connectorId, recordId } } : { title: "Untitled" } }).then(
      (env) => nav(`/envelopes/${env.id}`, { replace: true }),
      (e) => setError((e as Error).message),
    );
  }, [params, nav]);
  return <div className="max-w-xl mx-auto p-6">{error ? <ErrorNote>{error}</ErrorNote> : <Spinner label="Creating an envelope for this record…" />}</div>;
}
